import { FilterItemDto } from "../../general-types/filters.dto";

export const genderOptions: FilterItemDto[] = [
  { id: 1, name: "Male", value: 'male', icon: {name: 'mars', fill: '#F1F5F9', stroke: 'currentColor', strokeWidth: '2', type: 'fas'} },
  { id: 2, name: "Female", value: 'female', icon: {name: 'venus', fill: '#F1F5F9', stroke: 'currentColor', strokeWidth: '2', type: 'fas'} },
  { id: 3, name: "Other", value: 'other', icon: {name: 'circle', fill: '#F1F5F9', stroke: 'currentColor', type: 'far'} }
];
